import React from "react";
import {
  InputLabel,
  FormControl,
  Select,
  TextareaAutosize,
  Alert,
  Divider,
  Box,
  Typography,
  Button,
  Grid,
  MenuItem,
  TextField,
} from "@common-ui/ui";
import { useDispatch, useSelector } from "react-redux";
import { procedureSlice } from "../../../../reducers/procedureReducer";

const Instruction = ({
  sectionItem,
  sectionId,
  sectionItemIndex,
  sectionStep,
  step,
  handleRemoveSectionItem,
  subSectionStep,
  subSectionId,
}) => {
  const section = useSelector((state) =>
    state.procedure.items.find((section) => section.id === sectionId)
  );
  let subSection;
  if (subSectionId) {
    subSection = section.items.find((section) => section.id === subSectionId);
  }

  const getStep = (id) => {
    if (subSection) {
      console.log("subSection", subSection, step);
      return `${subSectionStep}.${
        Array.from(subSection.steps).indexOf(id) + 1
      }`;
    }
    return Array.from(section.steps).indexOf(id) + 1;
  };
  const dispatch = useDispatch();
  const handleDeleteItem = (id) => {
    dispatch(
      procedureSlice.actions.deleteItem({
        sectionId,
        sectionItemId: sectionItem.id,
        subSectionId,
        type: sectionItem.type,
      })
    );
  };
  return (
    <div>
      <span style={{ display: "flex", alignItems: "center" }}>
        <Typography fontWeight="700" sx={{ mr: 1 }}>{`${sectionStep}.${getStep(
          sectionItem.id
        )}`}</Typography>

        <Button
          onClick={() => handleDeleteItem()}
          // startIcon={<DeleteForever />}
          sx={{ fontWeight: 200 }}
          size="small"
        >
          Remove
        </Button>
      </span>
      <Grid>
        <Grid item md={12} xs={12}>
          <div>
            <InputLabel>Info Panel</InputLabel>
            <FormControl fullWidth name="na">
              <Select
                sx={{ mt: 1 }}
                onChange={(e) =>
                  dispatch(
                    procedureSlice.actions.updateSectionItems({
                      sectionId,
                      sectionItemId: sectionItem.id,
                      type: sectionItem.type,
                      name: "infoPanel",
                      value: e.target.value,
                      subSectionId,
                    })
                  )
                }
                size="small"
                placeholder="Select"
                name="infoPanel"
                variant="outlined"
                value={sectionItem.infoPanel}
                // displayEmpty
                // renderValue={() => "Select"}
              >
                <MenuItem value="none">
                  <em>None</em>
                </MenuItem>
                <MenuItem value={"Information"}>Information</MenuItem>
                <MenuItem value={"Warning"}>Warning</MenuItem>
                <MenuItem value={"Danger"}>Danger / Error</MenuItem>
              </Select>
            </FormControl>
          </div>
        </Grid>
        <Grid item md={12} xs={12}>
          {sectionItem.infoPanel === "Information" ? (
            <Alert sx={{ my: 2 }} severity="info">
              Information
            </Alert>
          ) : sectionItem.infoPanel === "Warning" ? (
            <Alert sx={{ my: 2 }} severity="warning">
              Warning
            </Alert>
          ) : sectionItem.infoPanel === "Danger" ? (
            <Alert sx={{ my: 2 }} severity="error">
              Danger / Error
            </Alert>
          ) : (
            <Box sx={{ my: 1 }}></Box>
          )}
          {/* <div>{<InfoPanel key={sectionItem.infoPanel} />}</div> */}
        </Grid>
        <Grid item md={12} xs={12}>
          <div>
            <InputLabel>Instruction</InputLabel>
            <TextField
              sx={{ mt: 1 }}
              size="small"
              fullWidth
              placeholder="Type"
              margin="normal"
              InputProps={{
                inputComponent: TextareaAutosize,
                inputProps: { minRows: 4 },
              }}
              name="content"
              value={sectionItem.content}
              onChange={(e) =>
                dispatch(
                  procedureSlice.actions.updateSectionItems({
                    sectionId,
                    sectionItemId: sectionItem.id,
                    type: sectionItem.type,
                    name: "content",
                    value: e.target.value,
                    subSectionId,
                  })
                )
              }
            />
          </div>
        </Grid>
      </Grid>
      {/* <div>Coming Soon!</div>  */}
      <Divider sx={{ my: 2 }} />
    </div>
  );
};

export default Instruction;
